;(function (window) {
  'use strict';

  var VersionManager = {}

  VersionManager.getVersion = function () {
    return '1743535993102'
  }

  VersionManager.buildUrl = function (path) {

    var extension = path.split('.').pop(),
      staticParams = '?t=' + this.getVersion()

    if (/js|css/.test(extension)) {
      staticParams += '&minifierType=' + extension
    }

    return path + staticParams
  }

  window.VersionManager = VersionManager
})(window)
